<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	let min,
		max,
		local_ip = get_local_ip(id),
		loading = false;

	if (!device.type.includes('BTN')) {
		min = 100;
		max = 1000;
	} else {
		min = 200;
		max = 2000;
	}

	let value = settings.multipush_time_between_pushes_ms.max;
	let cache = value;

	const set_multi_duration = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (local_ip) {
				res = await localReq(device, `${local_ip}/settings/`, 'post', {
					multipush_time_between_pushes_ms_max: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/multipush_duration`, {
					id: id,
					max: value,
				});
			}

			if (res.isok) {
				settings.multipush_time_between_pushes_ms.max = value;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title:
						$format('multipushes_time_scc_toast', { values: { value } }) ||
						`Time between pushes was set to ${value}ms.`,
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('multipush_description', { values: { min, max } }) ||
		'Max time between pushes in milliseconds (must be between {min} and {max}).'}
</Text>
<Input
	class="mb-s"
	size="m"
	icon="fas fa-clock"
	bind:value
	type={'number'}
	{min}
	{max}
	on:enter={set_multi_duration}
	id="input-5egnofd"
	aria-label={$format('multipush_description', { values: { min, max } }) ||
		'Max time between pushes in milliseconds (must be between {min} and {max}).'}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={set_multi_duration}>
	{$format('button_save')}
</Button>
